import React from "react";
import { HighChart } from "../Generic/Charts";
import Highcharts from "highcharts";
import ChartModuleMore from "highcharts/highcharts-more.js";
import HCSoldGauge from "highcharts/modules/solid-gauge";

ChartModuleMore(Highcharts);
HCSoldGauge(Highcharts);
const GaugeChart: React.FC<{
  chartName: string;
  data: number;
}> = ({ chartName, data }) => {
  const chartOptions = {
    chart: {
      type: "gauge",
      plotBackgroundColor: null,
      plotBackgroundImage: null,
      plotBorderWidth: 0,
      plotShadow: false,
    },

    title: {
      text: "",
    },

    pane: {
      startAngle: -90,
      endAngle: 89.9,
      background: null,
      center: ["50%", "75%"],
      size: "100%",
    },

    // the value axis
    yAxis: {
      min: 0,
      max: 100,
      tickPixelInterval: 72,
      tickPosition: "inside",
      tickColor: Highcharts.defaultOptions.chart?.backgroundColor || "#FFFFFF",
      tickLength: 20,
      tickWidth: 2,
      minorTickInterval: null,
      labels: {
        distance: 20,
        style: {
          fontSize: "18px",
        },
      },
      lineWidth: 0,
      plotBands: [
        {
          from: 0,
          to: 90,
          color: "#55BF3B", // green
          thickness: 20,
        },
        {
          from: 90,
          to: 95,
          color: "#DDDF0D", // yellow
          thickness: 20,
        },
        {
          from: 95,
          to: 100,
          color: "#DF5353", // red
          thickness: 20,
        },
      ],
    },

    series: [
      {
        name: chartName,
        data: [Math.floor(data)],
        tooltip: {
          valueSuffix: "%",
        },
        dataLabels: {
          format: "{y}%",
          borderWidth: 0,
          color:
            (Highcharts.defaultOptions.title &&
              Highcharts.defaultOptions.title.style &&
              Highcharts.defaultOptions.title.style.color) ||
            "#333333",
          style: {
            fontSize: "16px",
          },
        },
        dial: {
          radius: "80%",
          backgroundColor: "gray",
          baseWidth: 12,
          baseLength: "0%",
          rearLength: "0%",
        },
        pivot: {
          backgroundColor: "gray",
          radius: 6,
        },
      },
    ],
  };
  return (
    <HighChart cardTitleLarge={chartName} colSize="12" options={chartOptions} />
  );
};

export default GaugeChart;
